import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ReactComponent as InfoIcon } from '../../../assets/images/svg/info-filled-blue.svg';
import themeColors from '../../../assets/styles/themeColors';
import { variables } from '../../../assets/styles/variables';
import BottomDrawer from '../../Drawer/Drawer';
import Button from '../../Button/Button';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 8px 8px 0;
  text-align: center;

  > svg {
    width: 36px;
    height: 36px;
  }
`;

const Title = styled.div`
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 1;
  color: ${themeColors.colorTextPrimary};
`;

const Message = styled.div`
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: ${themeColors.colorTextSecondary};
`;

const SupportLink = styled.a`
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  color: ${themeColors.colorSfhActionBlue};
  text-decoration: underline;
  margin-top: 4px;
`;

const DrawerFooter = styled.div`
  > button {
    width: 100%;
    font-family: ${variables.family.goldSilverHeaders}, sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.3;
  }

  && > button,
  && > button:hover,
  && > button:focus,
  && > button:active {
    color: ${themeColors.colorSfhActionBlue};
    border-color: ${themeColors.colorSfhActionBlue};
  }
`;

const SellFromHomeBankTitleNoticeDrawer = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const phone = t('sellWizard.sfhWizard.phone');

  const footer = (
    <DrawerFooter>
      <Button
        variant="primaryOutlined"
        textTransform="none"
        onClick={onClose}
        data-cy="button-sfh-bank-title-understood"
      >
        {t('sellWizard.sfhWizard.bankTitleNotice.cta')}
      </Button>
    </DrawerFooter>
  );

  return (
    <BottomDrawer isOpen={isOpen} onClose={onClose} title="" footer={footer}>
      <Content>
        <InfoIcon />
        <Title>{t('sellWizard.sfhWizard.bankTitleNotice.title')}</Title>
        <Message>{t('sellWizard.sfhWizard.bankTitleNotice.message')}</Message>
        <SupportLink href={`tel:${phone.replace(/[^\d+]/g, '')}`}>
          {t('sellWizard.sfhWizard.needHelp')} {phone}
        </SupportLink>
      </Content>
    </BottomDrawer>
  );
};

SellFromHomeBankTitleNoticeDrawer.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default SellFromHomeBankTitleNoticeDrawer;
